import RouterView from "@/views/RouterView";
import ListeAssociationView from "@/views/association/ListeAssociationView";
import FicheAssociationView from "@/views/association/FicheAssociationView";
import ModificationView from "@/views/creation/ModificationView";
import DissolutionView from "@/views/creation/DissolutionView";
import RadiationView from "@/views/creation/RadiationView";
import { authentified } from "./AccesDecisions";
import { MODIFICATION_ASSOCIATION, DISSOLUTION_ASSOCIATION, RADIATION_ASSOCIATION, ONGLET_DETAIL } from "./associations";
export default [{
    path: "/association",
    component: RouterView,
    children: [
        {
            path: "",
            name: "liste-association",
            component: ListeAssociationView,
            meta: {
                auth: authentified()
            }
        },
        {
            path: ":numero/modification",
            props: route => ({
              numero: route.params.numero
            }),
            name: MODIFICATION_ASSOCIATION,
            component: ModificationView,
            meta: {
              auth: authentified()
            }
        },
        {
          path: ":numero/dissolution",
          props: route => ({
            numero: route.params.numero
          }),
          name: DISSOLUTION_ASSOCIATION,
          component: DissolutionView,
          meta: {
            auth: authentified()
          }
        },
        {
          path: ":numero/radiation",
          props: route => ({
            numero: route.params.numero
          }),
          name: RADIATION_ASSOCIATION,
          component: RadiationView,
          meta: {
            auth: authentified()
          }
        },
        {
            path: ":numero",
            props: route => ({
              numero: route.params.numero
            }),
            name: ONGLET_DETAIL,
            component: FicheAssociationView,
            meta: {
              auth: authentified()
            }
          },
    ],
}]
